


























































import QrLogo from 'qrcode-with-logos'
import Vue from 'vue'
import { Component, Emit, Prop, VModel } from 'vue-property-decorator'

import { successNotificationWrapper, warningNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import FieldTitle from '../../../../../Pi/components/FieldTitle.vue'

@Component({
  components: {
    FieldTitle,
  }
})
export default class FlowSettings extends Vue {
  @VModel() title!: string

  @Prop() link!: string

  @Prop() boardAvatar!: string

  @Emit('renameFlow')
  renameFlow(): void {
    return
  }

  copyText(text: string): void {
    try {
      // eslint-disable-next-line compat/compat
      navigator.clipboard.writeText(text)

      successNotificationWrapper(this.$t('success').toString(), this.$t('success_copy').toString())
    } catch (error) {
      warningNotificationWrapper(this.$t('error').toString(), this.$t('copy_fail').toString())
    }
  }

  mounted(): void {
    const img = document.getElementById('QRimage')

    if (img) {

      let qrcode = new QrLogo({
        content: this.link,
        width: 200,
        image: img as HTMLImageElement,
        logo: {
          src: this.boardAvatar,
          logoSize: 0.25,
          borderSize: 0.02,
          borderRadius: 50,
        }
      })

      qrcode.toImage()
    }
  }
}
